export const reducePointModes = {
    KK_BOX: 'kkbox',
    GENERAL: 'general',
    POINT_SYSTEMS: 'pointSystems'
};

export const enterprisePointInputModes = {
    NUMBER: 'number',
    CUSTOM_CODE: 'customCode'
};
